export const selectAllTasks = ({ TasksSlice: oState }) => oState?.aTasks;
